import { TaxValidationRequest, TaxValidationResponse } from '../utils/taxNumber/types';
import { v4 } from 'uuid';

const validateTaxIdentifier = async (regApiUrl: string, reqData: TaxValidationRequest): Promise<{ body: TaxValidationResponse }> => {
  return fetch(`${regApiUrl}/v1/taxIdentifier/validate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CorrelationId': v4()
    },
    body: JSON.stringify(reqData)
  }).then(response => response.json())
    .then(data => ({ body: data }));
};

export default {
  validateTaxIdentifier
};
